import {cr,URLS} from 'fire-wind-water';
import {interact} from 'fire-wind-water/tools/interact';
import {WxData} from './data';
import wx from './jweixin-1.6.0';

window.wx = wx;
export class WxSdk extends WxData {
  constructor() {
    super();
    this.postUrl = '';
    if (window.config && window.config.api && window.config.api.gateway) {
      this.postUrl = window.config.api.gateway.general;
    }

    this.jsApiListDef = [
      'onMenuShareTimeline', // 分享到微信朋友圈（兼容）
      'onMenuShareAppMessage', // 分享给朋友（兼容）
      'onMenuShareQQ', // 分享到QQ（兼容）
      'onMenuShareQZone', // 分享到QQ空间（兼容）
      'updateAppMessageShareData', // 分享给微信或QQ朋友
      'updateTimelineShareData', // 分享到微信朋友圈或QQ空间
      'onMenuShareWeibo', // 分享到腾讯微博
      'closeWindow', // 关闭当前网页窗口
      'hideMenuItems', // 批量隐藏功能按钮
      'showMenuItems', // 批量显示功能按钮
      'hideAllNonBaseMenuItem', // 隐藏所有非基础按钮
      'showAllNonBaseMenuItem', // 显示所有功能按钮
      'scanQRCode',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage',
      'checkJsApi'
    ];

    this.jsApiListNullTenant = [
      'scanQRCode',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage',
      'checkJsApi'
    ];
    this.wxEvent = {
      sharer: {},
      itself: {},
      menus: {}
    };
    this.trashEvent = {};
    this.isWxReady = false;
    this.checkJsApi = {};
  }

  initWxSdk(config, url, cn) {
    if (!interact.isWeChat) {
      return;
    }
    this.isWxReady = false;
    let setting = {
      tenantId: '',
      weChatId: '',
      jsApiList: this.jsApiListDef,
      url: window.location.href.split('#')[0],
      onDebug: 0
    };
    cr.extend(true, setting, config);
    if (!setting.tenantId) {
      throw new Error('缺少租户Id');
    }
    if (url) {
      this.postUrl = url;
    }
    if (!this.postUrl) {
      throw new Error('缺少服务器请求地址，在initWxSdk第二个参数中传入');
    }
    if (setting.weChatId) {
      this.getWxJssdkConfig(setting, this.postUrl).then(data => {
        if (data.result == 0) {
          this.initWxConfig(data.content, setting, cn);
        }
      });
    } else {
      this.getDefaultWxJssdkConfig(setting, this.postUrl).then(data => {
        if (data.result == 0) {
          this.initWxConfig(data.content, setting, cn);
        }
      });
    }
    return wx;
  }

  initWxConfig(config, settings, cn) {
    let setting = cr.extend(true, config, {
      appId: config.wxAppId,
      onDebug: settings.onDebug,
      jsApiList: config.jsApiList && config.jsApiList.length === 0 ? this.jsApiListNullTenant :settings.jsApiList
    });
    wx.config(setting);
    wx.ready(() => {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
      // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
      // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      this.isWxReady = true;
      wx.checkJsApi({
        jsApiList: settings.jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: (res) => {
          if (res && res.checkResult) {
            this.checkJsApi = res.checkResult;
            this.initSharerAll();
            this.initItselfAll();
            this.initMenusAll();
          }
        }
      });
      if (cr.isFunction(cn)) {
        cn(wx);
      }
    });
  }

  on(type, setting, cn) {
    // sharer  分享给朋友，分享到QQ   sharer_friends 分享到朋友圈、分享到QQ空间    sharer_weibo  分享到腾讯微博
    let sharer = ['sharer', 'sharer_friends', 'sharer_weibo'];
    let trash = [
      'onMenuShareWeibo',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareQZone'];
    let menus = ['hideMenuList', 'showMenuList', 'hideMenuAll', 'showMenuAll', 'closeWindow'];
    if (sharer.indexOf(type) !== -1) {
      this.setSharer(type, setting, cn);
      // this.initSharer();
      return;
    }
    if (trash.indexOf(type) !== -1) {
      this.trashEvent[type] = {
        type: type, setting: setting, cn: cn
      };
      window.console.log('设置了即将废弃的接口，请手动调用$swxsdk.confirmUseTrash()以确认，参数是废弃的api');
      return;
    }
    if (menus.indexOf(type) !== -1) {
      this.setMenus(type, setting, cn);
      this.initMenus();
      return;
    }
    this.setItself(type, setting, cn);
    this.initItself(this.wxEvent.itself[type]);
  }

  setItself(type, setting, cn) {
    this.wxEvent.itself[type] = {
      wx: type,
      params: setting,
      callback: cn || cr.noop
    };
    this.initItself(this.wxEvent.itself[type]);
  }

  initItself(d) {
    if (!this.isWxReady) {
      return;
    }
    const cns = {
      success: (res) => {
        // 设置成功
        d.callback({type: 'success', data: res});
      },
      fail: (res) => {
        // 设置成功
        d.callback({type: 'fail', data: res});
      },
      complete: (res) => {
        // 设置成功
        d.callback({type: 'complete', data: res});
      },
      cancel: (res) => {
        // 设置成功
        d.callback({type: 'cancel', data: res});
      },
      trigger: (res) => {
        // 设置成功
        d.callback({type: 'trigger', data: res});
      }
    };
    const json = cr.extend(true, d.params, cns);
    if (this.checkJsApi[d.wx]) {
      wx[d.wx](json);
    } else {
      // 再次尝试检查一下
      wx.checkJsApi({
        jsApiList: [d.wx], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function(res) {
          if (res && res.checkResult && res.checkResult[d.wx]) {
            wx[d.wx](json);
          } else {
            d.callback({
              type: 'checkJsApi',
              data: res
            });
          }
        }
      });
    }
  }

  initItselfAll() {
    cr.each(this.wxEvent.itself, (d) => {
      this.initItself(d);
    });
  }

  confirmUseTrash(str) {
    if (!this.trashEvent[str]) {
      return;
    }
    this.setSharer(this.trashEvent[str].type, this.trashEvent[str].setting, this.trashEvent[str].cn);
    // this.initSharer();
  }

  setSharer(type, setting, cn) {
    let sharer_wx = {
      sharer: 'updateAppMessageShareData',
      sharer_friends: 'updateTimelineShareData',
      sharer_weibo: 'onMenuShareWeibo',
      onMenuShareTimeline: 'onMenuShareTimeline',
      onMenuShareAppMessage: 'onMenuShareAppMessage',
      onMenuShareQQ: 'onMenuShareQQ',
      onMenuShareQZone: 'onMenuShareQZone'

    };
    this.wxEvent.sharer[type] = {
      wx: sharer_wx[type],
      params: {
        title: setting.title || '',
        desc: setting.desc || '',
        link: URLS.removeSearchParam(setting.link, 'code', 'appid', 'excode') || '',
        imgUrl: setting.imgUrl || ''
      },
      callback: cn || cr.noop
    };
    this.initSharer(this.wxEvent.sharer[type]);
  }

  initSharer(d) {
    if (!this.isWxReady) {
      return;
    }
    if (!this.checkJsApi[d.wx]) {
      d.callback({type: 'error', data: '当前客户端版本不支持' + d.wx});
    }
    wx[d.wx]({
      title: d.params.title, // 分享标题
      desc: d.params.desc, // 分享描述
      link: d.params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: d.params.imgUrl, // 分享图标
      success: (res) => {
        // 设置成功
        d.callback({type: 'success', data: res});
      },
      fail: (res) => {
        d.callback({type: 'fail', data: res});
      },
      complete: (res) => {
        d.callback({type: 'complete', data: res});
      },
      cancel: (res) => {
        d.callback({type: 'cancel', data: res});
      },
      trigger: (res) => {
        d.callback({type: 'trigger', data: res});
      }
    });
  }

  initSharerAll() {
    cr.each(this.wxEvent.sharer, (d) => {
      this.initSharer(d);
    });
  }

  setMenus(type, setting, cn) {
    let menu_wx = {
      hideMenuList: 'hideMenuItems',
      hideMenuAll: 'hideAllNonBaseMenuItem',
      showMenuList: 'showMenuItems',
      showMenuAll: 'showAllNonBaseMenuItem',
      closeWindow: 'closeWindow'
    };
    this.wxEvent.menus[type] = {
      wx: menu_wx[type],
      params: setting ? {menuList: setting.menuList || []} : '',
      callback: cn || cr.noop
    };
    this.initMenus(this.wxEvent.menus[type]);
  }

  initMenus(d) {
    if (!this.isWxReady) {
      return;
    }
    if (!this.checkJsApi[d.wx]) {
      d.callback({type: 'error', data: '当前客户端版本不支持' + d.wx});
    }
    wx[d.wx](d.params);
  }

  initMenusAll() {
    cr.each(this.wxEvent.menus, (d) => {
      this.initMenus(d);
    });
  }
}

// window.$swxsdk.on('hideMenuList', ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone"]);